import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpeedometer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 23,
	height: 19.898,
	viewBox: "0 0 23 19.898",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "speedometer-icon",
		transform: "translate(0 0)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_19325",
			"data-name": "Path 19325",
			d: "M10.884,9.917l5.353-3.41a.092.092,0,0,1,.122.011l.517.55a.094.094,0,0,1,0,.124L12.823,11.9a1.6,1.6,0,0,1-1.688.58,1.393,1.393,0,0,1-.627-.421,1.4,1.4,0,0,1,.372-2.145l0,0ZM3.618,19.872A11.5,11.5,0,0,1,11.5,0a11.4,11.4,0,0,1,4.385.872,11.6,11.6,0,0,1,6.239,6.24A11.389,11.389,0,0,1,21.08,17.826a11.763,11.763,0,0,1-1.423,1.741.094.094,0,0,1-.131,0l-.575-.573a.085.085,0,0,1-.032-.021l-1.6-1.6a.094.094,0,0,1,0-.131l.84-.84a.094.094,0,0,1,.131,0l1.237,1.237a10.244,10.244,0,0,0,.721-1.067,9.984,9.984,0,0,0,1.374-4.863H19.915a.094.094,0,0,1-.094-.094V10.426a.094.094,0,0,1,.094-.094h1.64a10.057,10.057,0,0,0-.883-3.1,10.217,10.217,0,0,0-1.838-2.69l-1.1,1.1a.094.094,0,0,1-.131,0l-.84-.84a.094.094,0,0,1,0-.131l1.058-1.058a10.15,10.15,0,0,0-2.783-1.591A10.027,10.027,0,0,0,11.9,1.383v1.5a.094.094,0,0,1-.094.094H10.62a.094.094,0,0,1-.094-.094V1.421A10.089,10.089,0,0,0,4.732,3.964l1.1,1.1a.094.094,0,0,1,0,.131l-.84.84a.094.094,0,0,1-.131,0L3.773,4.949A10.114,10.114,0,0,0,2.1,7.73a10.223,10.223,0,0,0-.7,3.169h1.69a.094.094,0,0,1,.094.094v1.19a.094.094,0,0,1-.094.094H1.4a10.043,10.043,0,0,0,.253,1.606A9.943,9.943,0,0,0,2.2,15.515a10.166,10.166,0,0,0,.681,1.306,9.862,9.862,0,0,0,.8,1.117l1.355-1.355a.094.094,0,0,1,.131,0l.84.84a.094.094,0,0,1,0,.131c-.775.775-1.514,1.518-2.263,2.313a.09.09,0,0,1-.129,0Z",
			fill: "var(--ant-primary-color)",
			transform: "translate(0 0)"
		})
	})]
});
const ForwardRef = forwardRef(SvgSpeedometer);
export default ForwardRef;
